import PropositionBloc from './proposition-bloc';

export default PropositionBloc;
